import styled from 'styled-components';
export const DialogCloseButtonDefaultBox = styled.button`
    position: absolute;
    right: 1.5rem;
    width: ${props => props.theme.components.modalDialog.closeButtonSize};
    height: ${props => props.theme.components.modalDialog.closeButtonSize};
    cursor: pointer;
    background-image: url("${props => props.theme.images.closeModalDialog.toString()}");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin: 0;

    &:hover {
        opacity: 0.5;
    }
`;